import { Insurance } from './Insurance'
import { PartnerFood } from './PartnerFood'

export enum PartnerTypes {
  Insurance = 'insurance',
  PartnerFood = 'partnerFood',
}

export type Partner = Insurance | PartnerFood

export const getPartnerDisplayName = (partner: Partner): string => {
  return partner.displayName || partner.name
}

export const getPartnerLogoImage = (partner: Partner, ratio = 2): string | null => {
  const { logo } = partner
  if (logo && logo?.length) {
    return logo.replace(/(.*\/x)(?:1)(-.*)/, `$1${ratio}$2`)
  }
  return null
}

export const getPartnerInlineLogoImage = (partner: Partner, ratio = 2): string | null => {
  const { inlineLogo } = partner
  if (inlineLogo && inlineLogo?.length) {
    return inlineLogo.replace(/(.*\/x)(?:1)(-.*)/, `$1${ratio}$2`)
  }
  return null
}
